import IconBlock from './IconBlock';

export default IconBlock;
